import { SupportedDeliveryTypes } from "../interfaces/InvoiceInterfaces.mjs";
import { capitalizeString } from "./TextUtil.mjs";
const getAddressAsText = (address) => {
  if (Object.keys(address).length === 0) {
    return "";
  }
  const houseName = [address.street, address.building].join(" ") + (address.room ? "-".concat(address.room) : "");
  return [
    capitalizeString(houseName),
    [address.city ? capitalizeString(address.city) : capitalizeString(address.municipality), address.postalCode].join(" "),
    capitalizeString(address.region)
  ].join(", ");
};
const contactAddressMatchesInvoiceDeliveryAddress = (contactInfoEmail, contactInfoAddress, invoiceSettings) => {
  let emailAddressExistsOnInvoices, addressExistsOnInvoices;
  if (contactInfoEmail) {
    emailAddressExistsOnInvoices = hasInvoicesWithDeliveryType(invoiceSettings, SupportedDeliveryTypes.EMAIL) ? invoiceSettings.filter((invoice) => invoice.invoiceDeliveries.includes(SupportedDeliveryTypes.EMAIL)).every((invoice) => invoice.emailAddresses.includes(contactInfoEmail)) : true;
  } else {
    emailAddressExistsOnInvoices = true;
  }
  if (contactInfoAddress) {
    addressExistsOnInvoices = hasInvoicesWithDeliveryType(invoiceSettings, SupportedDeliveryTypes.POST) ? invoiceSettings.filter((invoice) => invoice.invoiceDeliveries.includes(SupportedDeliveryTypes.POST)).every((invoice) => validateInvoiceAndContactAddressAreEqual(invoice.address, contactInfoAddress)) : true;
  } else {
    addressExistsOnInvoices = true;
  }
  return emailAddressExistsOnInvoices && !!addressExistsOnInvoices;
};
const hasInvoicesWithDeliveryType = (invoiceSettings, deliveryType) => {
  return invoiceSettings == null ? void 0 : invoiceSettings.some((invoice) => invoice.invoiceDeliveries.includes(deliveryType));
};
const validateInvoiceAndContactAddressAreEqual = (invoiceAddress, contactAddress) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if (!invoiceAddress) {
    return false;
  }
  return ((_a = contactAddress.city) == null ? void 0 : _a.toUpperCase()) === ((_b = invoiceAddress.city) == null ? void 0 : _b.toUpperCase()) && ((_c = contactAddress.municipality) == null ? void 0 : _c.toUpperCase()) === ((_d = invoiceAddress.municipality) == null ? void 0 : _d.toUpperCase()) && ((_e = contactAddress.region) == null ? void 0 : _e.toUpperCase()) === ((_f = invoiceAddress.county) == null ? void 0 : _f.toUpperCase()) && contactAddress.postalCode === invoiceAddress.zipCode && ((_g = contactAddress.street) == null ? void 0 : _g.toUpperCase()) === ((_h = invoiceAddress.streetName) == null ? void 0 : _h.toUpperCase()) && contactAddress.building === invoiceAddress.houseNumber && contactAddress.room === invoiceAddress.apartmentNumber;
};
export {
  contactAddressMatchesInvoiceDeliveryAddress,
  getAddressAsText
};
